var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssistantIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.445 2.12v.553l.003.916V7.25l1.931-1.75a.666.666 0 01.784-.087.737.737 0 01.357.648v7.62c0 3.815-3.088 6.897-6.823 6.736-3.349-.146-6.08-2.933-6.25-6.381a6.944 6.944 0 01.518-3.013A6.642 6.642 0 017.277 9.03L12.943 3l.735-.776.588-.625a.672.672 0 01.874-.095.74.74 0 01.305.616zm-7.028 7.913l5.91-6.267V8.29a.65.65 0 00.32.576c.23.127.5.094.695-.08l1.713-1.554v6.397c0 2.783-2.08 5.141-4.773 5.293-2.914.165-5.337-2.236-5.337-5.209 0-1.39.524-2.697 1.472-3.68z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.925 16.39c-1.118 0-2.024-.933-2.024-2.086 0-1.152.906-2.085 2.024-2.085v4.17zM19.075 12.22v2.8c-.546 3.082-2.938 5.505-5.945 6.005-.268.044-.54.06-.809.06h-1.235v.417c0 .185.04.37.132.527.207.352.58.586 1.009.586a1.19 1.19 0 001.159-.993c2.78-.52 5.056-2.562 5.979-5.256.979-.145 1.734-1.01 1.734-2.062 0-1.15-.908-2.085-2.024-2.085zM10.825 14.756h-1.32a.229.229 0 01-.225-.232v-1.36c0-.128.101-.232.225-.232h1.32c.124 0 .225.104.225.231v1.361a.229.229 0 01-.225.232zM14.98 14.756h-1.32a.229.229 0 01-.225-.232v-1.36c0-.128.101-.232.225-.232h1.32c.124 0 .225.104.225.231v1.361a.229.229 0 01-.225.232z",
    fill: "#999"
  })));
}

export default __webpack_public_path__ + "d9b321116046b708711252279769a89a.svg";
export { SvgAssistantIcon as ReactComponent };